import EventBus from "@packages/event-bus";
import Vue from "vue";
import base from "./baseCore";

const listOrUndefined = (value) =>
    Array.isArray(value) && value.length ? value : undefined;

const termOrUndefined = (usageTerms) => {
    const term = Array.isArray(usageTerms) ? usageTerms[0] : usageTerms;
    return term === undefined || term === null ? undefined : term;
};

const buildRequestBody = (
    {
        search,
        orderBy,
        desc,
        date,
        advertising,
        local,
        establishments,
        usageTerms,
    } = {},
    page
) => {
    return {
        page: page || 0,
        filter: search || undefined,
        startDate: (date && date.min) || undefined,
        endDate: (date && date.max) || undefined,
        accountIds: listOrUndefined(establishments),
        localTreeIds: listOrUndefined(local),
        campaigns: listOrUndefined(advertising),
        order: orderBy || undefined,
        isDesc: !!desc,
        termId: termOrUndefined(usageTerms),
    };
};

export default Object.assign(
    {
        apiUrl: "/acesso/lead",

        urlAdmin: "/cliente",

        async list({ page, filters }) {
            const url = this.url();

            return await Vue.http.post(url, buildRequestBody(filters, page));
        },

        async csv({ filters }) {
            return Vue.http({
                url: this.url(`/csv`),
                method: "POST",
                responseType: "blob", // important
                data: buildRequestBody(filters),
            });
        },

        async removeClient(id) {
            const url = this.adminUrl(`/${id}`);
            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http.delete(url).catch((error) => {
                EventBus.$emit("CANCEL_SPINNER");
                throw error;
            });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async listExternal({ page, filters }) {
            const url = this.userUrl({ path: `/third-party/client/view` });

            return Vue.http.get(url, {
                params: {
                    ...filters,
                    page
                },
            });
        },

        async listDatabases({ page, search }) {
            const url = this.userUrl({ path: `/third-party/database/view` });

            const response = await Vue.http.get(url, {
                params: {
                    search,
                    page
                },
            });

            return response.content
        },

        async uploadDatabase({ data }) {
            const url = this.userUrl({ path: `/third-party/database/upload` });

            return Vue.http.post(url, data,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
        },

        async countExternal({ filters }) {
            const url = this.userUrl({ path: `/third-party/client/count` });

            return Vue.http.get(url, {
                params: {
                    ...filters,
                },
            });
        },

        async listMarketingAutomationSends() {
            const url = this.url(`/third-party/automation`);

            return Vue.http.get(url);
        },

        async getMarketingAutomationSendById(id) {
            const url = this.url(`/third-party/automation/${id}`);

            return Vue.http.get(url);
        },

        async createMarketingAutomationSend({ date, automationFlowId, databaseId }) {
            const url = this.url(`/third-party/automation`);

            return Vue.http.post(url, { date, automationFlowId, databaseId });
        },

        async editMarketingAutomationSend({ id, date, automationFlowId, databaseId }) {
            const url = this.url(`/third-party/automation/${id}`);

            return Vue.http.put(url, { date, automationFlowId, databaseId });
        },

        async deleteMarketingAutomationSend(id) {
            const url = this.url(`/third-party/automation/${id}`);

            return Vue.http.delete(url);
        },

        async listExternalDatabases({ page, search }) {
            const url = this.userUrl({ path: `/third-party/database/view` });

            const response = await Vue.http.get(url, {
                params: {
                    search,
                    page
                },
            });

            return response.content
        },
    },
    base
);
